module.exports = __webpack_public_path__ + "static/media/VPM_laptop_3.dd3c99ae.jpg";